module.exports = __webpack_public_path__ + "img/Citrus_sinensis.8e343414.jpg";